import Vue from "vue";
import Vuex from "vuex";
import swal from "sweetalert2";
import router from "../router/index";

Vue.use(Vuex);

// realtime firebase
// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

function catchAlert(title, e, type) {
    let msg = "";
    switch (e.code) {
        case "auth/invalid-email":
            msg = "Por favor captura un email válido";
            break;
        case "auth/wrong-password":
            msg = "Contraseña inválida";
            break;
        case "auth/too-many-requests":
            msg =
                "Demasiados intentos fallidos, intenta más tarde o recupera tu contraseña";
            break;
        case "auth/email-already-in-use":
            msg = "Este correo ya está dado de alta, recupera tu contraseña";
            break;
        case "auth/user-not-found":
            msg = "Este usuario no existe en nuestros registros, crea una cuenta";
            break;
        default:
            msg = "Hubo un error inesperado, por favor intenta de nuevo";
            break;
    }
    swal.fire(title, msg, type);
}

function sendAlert(title, msg, type) {
    swal.fire(title, msg, type);
}

function custom_sort(a, b) {
    return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
}

const store = new Vuex.Store({
    state: {
        overlay: false,
        loading: false,
        userProfile: {},
        posts: [],
        ticket: {
            id: null,
            puntos: null,
            time: null,
            time_txt: null,
            ini_time: null,
            fin_time: null,
        },
        tickets: [],
        pregs: [],
        servicios: [{
                nombre: "Camisas y blusas",
                img: 'camisas-y-blusas',
                listado: [
                    "Ajuste de costados",
                    "Ajuste de largo de hombros",
                    "Ajuste de mangas",
                    "Ajuste de tirantes",
                    "Cambiar botones",
                    "Cambiar o eliminar hombreras",
                    "Cambio de cuello",
                    "Cambio de tirantes",
                    "Colocar hombreras",
                    "Cortar mangas",
                    "Dobladillos de largo",
                    "Eliminar pinzas",
                    "Hacer aberturas",
                    "Hacer pinzas",
                    "Modificación de escote",
                    "Subir puños",
                    "Voltear cuellos",
                ],
                toggle: false,
            },
            {
                nombre: "Pantalones y shorts",
                img: 'pantalones-y-shorts',
                listado: [
                    "Ajuste de cintura y cadera",
                    "Ajuste de piernas",
                    "Ajuste de tiro",
                    "Aumentar cintura",
                    "Bajar pretina",
                    "Cambiar elástico en cintura",
                    "Cambiar forro",
                    "Cierre de nylon",
                    "Cierre invisible",
                    "Cierre metálico",
                    "Colocar forro",
                    "Dobladillos a mano",
                    "Dobladillos a máquina",
                    "Eliminar bolsas",
                    "Eliminar forro",
                    "Eliminar pinzas",
                    "Hacer aberturas",
                    "Hacer bolsas",
                    "Hacer pinzas",
                    "Reducir cintura",
                    "Valencianas",

                ],
                toggle: false,
            },
            {
                nombre: "Faldas",
                img: 'faldas',
                listado: [
                    "Ajuste de cintura y cadera",
                    "Aumentar cintura",
                    "Bajar pretina",
                    "Cambiar elástico en cintura",
                    "Cambiar forro",
                    "Cierre de nylon",
                    "Cierre invisible",
                    "Cierre metálico",
                    "Colocar forro",
                    "Dobladillos a mano",
                    "Dobladillos a máquina",
                    "Eliminar bolsas",
                    "Eliminar forro",
                    "Eliminar pinzas",
                    "Hacer aberturas",
                    "Hacer bolsas",
                    "Hacer pinzas",
                    "Reducir cintura",

                ],
                toggle: false,
            },
            {
                nombre: "Vestidos",
                img: 'vestidos',
                listado: [
                    "Ajuste de costados",
                    "Ajuste de largo de hombros",
                    "Ajuste de mangas",
                    "Ajuste de tirantes",
                    "Cambiar botones",
                    "Cambiar elástico en cintura",
                    "Cambiar forro",
                    "Cambiar o eliminar hombreras",
                    "Cambio de tirantes",
                    "Cierre de nylon",
                    "Cierre invisible",
                    "Cierre metálico",
                    "Colocar forro",
                    "Colocar hombreras",
                    "Cortar mangas",
                    "Dobladillos a mano",
                    "Dobladillos a máquina",
                    "Eliminar bolsas",
                    "Eliminar forro",
                    "Eliminar pinzas",
                    "Hacer aberturas",
                    "Hacer bolsas",
                    "Hacer pinzas",
                    "Modificación de escote",

                ],
                toggle: false,
            },
            {
                nombre: "Sacos y Blazers",
                img: 'sacos-y-blazers',
                listado: [
                    "Ajuste de costados ",
                    "Ajuste de espalda ",
                    "Ajuste de largo de hombros ",
                    "Ajuste de solapa ",
                    "Arruga madre ",
                    "Cambio de hombreras ",
                    "Cambio forro ",
                    "Colocar botón ",
                    "Dobladillo de manga con martillo ",
                    "Dobladillo de manga sin martillo ",
                    "Fajilla con aberturas ",
                    "Fajilla sin aberturas ",

                ],
                toggle: false,
            },
            {
                nombre: "Abrigos y Gabardinas",
                img: 'abrigos-y-gabardinas',
                listado: [
                    "Ajuste de costados ",
                    "Ajuste de largo de hombros ",
                    "Cambiar hombreras ",
                    "Cambio de botones ",
                    "Cambio de Forro ",
                    "Cambio de puños ",
                    "Dobladillo de manga con martillo ",
                    "Dobladillo de manga sin martillo ",
                    "Elástico en cintura ",
                    "Elástico en puños ",
                    "Fajilla con aberturas ",
                    "Fajilla sin aberturas ",

                ],
                toggle: false,
            },
            {
                nombre: "Chamarras",
                img: 'chamarras',
                listado: [
                    "Ajuste de costados ",
                    "Cambiar forro ",
                    "Cambiar hombreras ",
                    "Cierre ",
                    "Dobladillo de largo ",
                    "Elástico en cintura ",
                    "Elástico en puños ",
                    "Subir puños ",

                ],
                toggle: false,
            },
            {
                nombre: "Bañadores y Lencería",
                img: 'banadores-y-lenceria',
                listado: [
                    "Ajuste de tirantes ",
                    "Ajuste de cintura ",
                    "Cambio de broches ",
                    "Elástico en cintura ",
                    "Elástico en piernas ",

                ],
                toggle: false,
            },
            {
                nombre: "Cortinas y Ropa de Cama",
                img: 'cortinas-y-ropa-de-cama',
                listado: [
                    "Metro de costura a máquina ",
                    "Metro de costura a mano ",

                ],
                toggle: false,
            },
            {
                nombre: "Modificación y Transformación de Prendas",
                img: 'modificacion-y-transformacion-de-prendas',
                listado: [],
                toggle: false,
            },
            {
                nombre: "Bordados",
                img: 'bordados',
                listado: [],
                toggle: false,
            },
            {
                nombre: "Etiquetas",
                img: 'etiquetas',
                listado: [],
                toggle: false,
            },
            {
                nombre: "Planchado",
                img: 'planchado',
                listado: [
                    "Pantalones",
                    "Jeans",
                    " Camisas",
                    "Shorts",
                    "Faldas",
                    "Playera",

                ],
                toggle: false,
            },
            {
                nombre: "Arreglos de Disfraces",
                img: 'arreglos-de-disfraces',
                listado: [],
                toggle: false,
            },
            {
                nombre: "Alta Costura",
                img: 'alta-costura',
                listado: [],
                toggle: false,
            },
        ],
    },
    getters: {
        ticketID(state) {
            state.ticket.id = localStorage.getItem("id_ultimo_ticket");
            return state.ticket.id;
        },
        timeInit(state) {
            state.ticket.ini_time = localStorage.getItem("ticket_ini_time");
            return state.ticket.ini_time;
        },
        pregs(state) {
            state.pregs = JSON.parse(localStorage.getItem("pregs"));
            return state.pregs;
        },
    },
    mutations: {
        showLoader(state, val) {
            state.loading = val;
        },
        setUserProfile(state, val) {
            state.userProfile = val;
        },
        setPerformingRequest(state, val) {
            state.performingRequest = val;
        },
        setPosts(state, val) {
            state.posts = val;
        },
        setTicketID(state, val) {
            localStorage.setItem("id_ultimo_ticket", val);
            state.ticket.id = val;
        },
        setTimeInit(state, val) {
            if (
                localStorage.getItem("ticket_ini_time") == null ||
                localStorage.getItem("ticket_ini_time") == ""
            ) {
                localStorage.setItem("ticket_ini_time", val);
                state.ticket.ini_time = val;
            }
        },
        removeTimeInit(state, val = null) {
            localStorage.setItem("ticket_ini_time", "");
            localStorage.setItem("pregs", "");
            state.ticket.ini_time = "";
        },
        setTicket(state, data) {
            state.ticket.puntos = data.puntos;
            state.ticket.time = data.time;
            state.ticket.time_txt = data.time_txt;
        },
        setTickets(state, data) {
            console.log("setting tickets");
            state.tickets = data;
        },
        setPregs(state, data) {
            if (
                localStorage.getItem("pregs") == null ||
                localStorage.getItem("pregs") == ""
            ) {
                localStorage.setItem("pregs", JSON.stringify(data));
                state.pregs = data;
            }
        },

    },
    actions: {
        logoutReportes({ commit }) {

            console.log('logout clic')
                // log user out
            localStorage.clear();

            // clear user data from state
            commit("setUserProfile", {});

            // redirect to login view
            router.push("/");
        },
    },
});

export default store;